<template>
  <span class="full-width WBUDKlassifizierungsCell">
    <v-sheet class="elevation-2 pa-4 grey lighten-2 mr-2 ml-2 rounded-t-lg">
      <v-text-field v-model="search" placeholder="Filter" solo hide-details clearable prepend-icon="mdi-magnify" clear-icon="mdi-close-circle" />
    </v-sheet>
    <v-card elevation="2" class="mr-2 ml-2 specification-treeview rounded-t-0">
      <v-card-text :style="{ height: cell.height + 'px' }" class="hide-scrollbar">
        <v-treeview
          :items="klassifizierungen"
          dense
          rounded
          open-on-click
          activatable
          color="green"
          :search="search"
          :filter="filter"
          :open.sync="open"
          @update:active="onItemClick"
        >
          <template v-slot:label="{ item }">
            <span v-if="item.parentId === 0" class="subtitle-1" style="max-height: 10px">
              <b>{{ item.name }}</b>
            </span>
            <span class="subtitle-1" v-else>
              {{ item.name }}
            </span>
          </template>
          <template v-slot:prepend="{ item }">
            <v-icon v-if="item.children.length === 0 && item.id === input.klassifizierung" color="green"> mdi-check-circle </v-icon>
            <v-icon v-else-if="item.children.length === 0"> mdi-circle-outline </v-icon>
          </template>
        </v-treeview>
      </v-card-text>
    </v-card>
  </span>
</template>

<script>
import { mapState } from 'vuex';
import vehicleMixin from '@/mixins/vehicleMixin';

export default {
  mixins: [vehicleMixin],
  props: {
    cell: { type: Object, required: true },
    namespace: { type: String, required: true },
    mIndex: { type: String, default: '' },
  },
  data() {
    return {
      open: [],
      search: null,
    };
  },
  computed: {
    ...mapState('wagenbuch', ['klassifizierungenByFzgTypeIdFk', 'selectedFahrzeugObj', 'wbConfigs', 'dataLoaded']),
    klassifizierungen() {
      // return this.klassifizierungenByFzgTypeIdFk[this.selectedFahrzeugObj.typIdFk].filter((k) => k.instance === this.classificationInstance);
      if (this.vehicle && this.klassifizierungenByFzgTypeIdFk[this.vehicle.typIdFk]) {
        return this.klassifizierungenByFzgTypeIdFk[this.vehicle.typIdFk].filter((k) => k.instance === this.classificationInstance);
      }
      return [];
    },
    wbType() {
      return this.$route.params.wbType;
    },
    classificationInstance() {
      return this.wbConfigs[this.wbType] && this.wbConfigs[this.wbType].classificationInstance ? this.wbConfigs[this.wbType].classificationInstance : 1;
    },
    lowerCaseSearch() {
      return this.search && this.search.toLowerCase();
    },
    input: {
      get() {
        return this.$store.state[this.namespace].formInput;
      },
      set(val) {
        this.$store.state[this.namespace].formInput = val;
      },
    },
    filter() {
      return (item, search, textKey) => {
        let value = item[textKey];
        if (value) {
          value = value.toLowerCase();
        }
        console.debug('Filter with search=', this.lowerCaseSearch, 'value', value);

        return value.includes(this.lowerCaseSearch);
        // item[textKey].toLowerCase().indexOf(search.toLowerCase()) > -1;
      };
    },
  },
  methods: {
    onItemClick(selected) {
      this.$set(this.input, 'klassifizierung', selected.pop());
    },

    filter_() {
      return this.caseSensitive ? (item, search, textKey) => item[textKey].indexOf(search) > -1 : undefined;
    },
  },
};
</script>

<style scoped>
.specification-treeview {
  max-height: 60%;
  overflow: auto;
}
</style>
